<template>
  <transition name="vue-go-top">
    <a class="to-top" @click="GoTop" :class="{ 'd-block': isActive }">
      <i class="fa fa-angle-up"> </i>
    </a>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex';
import throttle from 'lodash/throttle';

export default {
  name: 'go-top-button',
  data() {
    return {
      isActive: false,
      throttleScroll: null,
      throttleResize: null,
    };
  },
  mounted() {
    this.throttleScroll = throttle(this.HandleScroll, 100);
    this.throttleResize = throttle(this.HandleResize, 100);
    window.addEventListener('resize', this.throttleResize);
    window.addEventListener('scroll', this.throttleScroll);
  },
  beforeDestroy() {
    if (this.throttleResize) {
      window.removeEventListener('resize', this.throttleResize);
    }
    if (this.throttleScroll) {
      window.removeEventListener('scroll', this.throttleScroll);
    }
  },
  created() {},
  methods: {
    GoTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    },
    HandleScroll(e) {
      this.isActive = window.pageYOffset > this.boundary;
    },
    HandleResize(e) {},
  },
  computed: {
    ...mapGetters({}),
  },
  watch: {},
  components: {},
  props: {
    boundary: {
      type: Number,
      default: 200,
    },
  },
};
</script>
<style scoped>
.to-top {
  color: white !important;
}
.vue-go-top-enter-active,
.vue-go-top-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}
.vue-go-top-enter,
.vue-go-top-leave-to {
  opacity: 0;
  transform: translateY(50px);
}
</style>
